/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ago_Stale_Bee_TalkInputs */

const fr_ago_stale_bee_talk = /** @type {(inputs: Ago_Stale_Bee_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun`)
};

/**

* @param {Ago_Stale_Bee_TalkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const ago_stale_bee_talk = /** @type {((inputs?: Ago_Stale_Bee_TalkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ago_Stale_Bee_TalkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_ago_stale_bee_talk(inputs)
});